import askseed from "assets/shared/characters/Arkseed.png";
import bullseye from "assets/shared/characters/Bullseye Bot.png";
import buzz from "assets/shared/characters/Buzz Saw.png";
import chanchito from "assets/shared/characters/Chanchito final.png";
import deedles from "assets/shared/characters/Deedles.png";
import deepblue from "assets/shared/characters/DeepBlue0.png";
import denzillion from "assets/shared/characters/Denzillion final.png";
import detective from "assets/shared/characters/Detective.png";
import firewall from "assets/shared/characters/Firewall.png";
import goldeagle from "assets/shared/characters/Gold-Angel wings.png";
import grister from "assets/shared/characters/Gritster.png";
import iron from "assets/shared/characters/Iron Hammer.png";
import jolt from "assets/shared/characters/Jolt.png";
import kamzar from "assets/shared/characters/Karmzah.png";
import kid from "assets/shared/characters/Kid Einstein.png";
import chondrian from "assets/shared/characters/MightyChondrian.png";
import ninja from "assets/shared/characters/Ninja.png";
import repete from "assets/shared/characters/Re-Pete.png";
import toolbox from "assets/shared/characters/Tool Box.png";
import tryguy from "assets/shared/characters/Tri Guy.png";
import washinton from "assets/shared/characters/Washington.png";

export const heroes = [
  detective,
  firewall,
  goldeagle,
  grister,
  iron,
  askseed,
  bullseye,
  buzz,
  chanchito,
  deedles,
  deepblue,
  denzillion,
  washinton,
  tryguy,
  toolbox,
  repete,
  ninja,
  chondrian,
  kid,
  kamzar,
  jolt,
];
